import {Routes} from '@angular/router';

export const routes: Routes = [

    {
        path: '',
        loadChildren: () =>
            import('./pages/home/home.module').then((m) => m.HomeModule),
    },
    {
        path: ':param1/:param2/thank-you',
        loadChildren: () =>
            import('./pages/thank-you/thank-you.module').then((m) => m.ThankYouModule),
    },
    {
        path: 'courses',
        loadChildren: () =>
            import('./pages/courses/courses.module').then((m) => m.CoursesModule),
    },
    {
        path: 'blogs',
        loadChildren: () =>
            import('./pages/blogs/blogs.module').then((m) => m.BlogsModule),
    },
    {
        path: 'activities',
        loadChildren: () =>
            import('./pages/activities/activities.module').then((m) => m.ActivitiesModule),
    },
    {
        path: 'shop',
        loadChildren: () =>
            import('./pages/shop/shop.module').then((m) => m.ShopModule),
    },
    {
        path: 'about',
        loadChildren: () =>
            import('./pages/about/about.module').then((m) => m.AboutModule),
    },
    {
        path: 'artworks',
        loadChildren: () =>
            import('./pages/artworks/artworks.module').then((m) => m.ArtworksModule),
    },
    {
        path: 'rooftop-for-corporates',
        loadChildren: () =>
            import('./pages/corporates/corporates.module').then((m) => m.CorporatesModule),
    },
    {
        path: 'thecircle',
        loadChildren: () =>
            import('./pages/circle/circle.module').then((m) => m.CircleModule),
    },
    {
        path: 'team',
        loadChildren: () =>
            import('./pages/team/team.module').then((m) => m.TeamModule),
    },
    {
        path: 'onboarding',
        loadChildren: () =>
            import('./pages/onboarding/onboarding.module').then((m) => m.OnboardingModule),
    },
    {
        path: 'faqs',
        loadChildren: () =>
            import('./pages/faq/faq.module').then((m) => m.FaqModule),
    },
    {
        path: 'profile',
        loadChildren: () =>
            import('./pages/profile/profile.module').then((m) => m.ProfileModule),
    },
    {
        path: 'cart',
        loadChildren: () =>
            import('./pages/cart/cart.module').then((m) => m.CartModule),
    },
    {
        path: 'checkout',
        loadChildren: () =>
            import('./pages/checkout/checkout.module').then((m) => m.CheckoutModule),
    },
    {
        path: 'contact',
        loadChildren: () =>
            import('./pages/contact/contact.module').then((m) => m.ContactModule),
    },
    {
        path: 'privacy-policy',
        loadChildren: () =>
            import('./pages/privacy-policy/privacy-policy.module').then((m) => m.PrivacyPolicyModule),
    },
    {
        path: 'cancellation-policy',
        loadChildren: () =>
            import('./pages/cancellation-policy/cancellation-policy.module').then((m) => m.CancellationPolicyModule),
    },
    {
        path: 'terms-and-conditions',
        loadChildren: () =>
            import('./pages/terms/terms.module').then((m) => m.TermsModule),
    },
    {
        path: 'art-wiki',
        loadChildren: () =>
            import('./pages/art-wiki/art-wiki.module').then((m) => m.ArtWikiModule),
    },
    {
        path: 'masterclass',
        loadChildren: () =>
            import('./pages/masterclass/masterclass.module').then((m) => m.MasterclassModule),
    },
    {
        path: 'sitemap',
        loadChildren: () =>
            import('./pages/sitemap/sitemap.module').then((m) => m.SitemapModule),
    },
    {
        path: 'page-not-found',
        loadChildren: () =>
            import('./pages/error/error.module').then((m) => m.ErrorModule),
    },

    // Here add new pages component

    {
        path: '**',
        loadChildren: () =>
            import('./pages/error/error.module').then((m) => m.ErrorModule),
    },
];
